// extracted by mini-css-extract-plugin
export var childrenContainer = "_4s-0";
export var virtualScrollArea = "_4s-1";